module.exports = require("readline");


//////////////////
// WEBPACK FOOTER
// external "readline"
// module id = 90
// module chunks = 0